export default __webpack_public_path__ + "static/heron-acfdd1237acd64fcce5a23afd1b3859c.png";